module.exports = __webpack_public_path__ + "static/media/message02.e0775700.png";